// Module
var code = `<div appHeaderBar *ngIf="successDisplay === 'payment'">
    <header-bar-title>Make A Payment</header-bar-title>
</div>

<div appHeaderBar *ngIf="successDisplay === 'schedule'">
    <header-bar-title>Schedule A Payment</header-bar-title>
</div>

<div *ngIf="false">
    <!--
    This page is an ending point for two different work flows.
    Payment and Schedule payments have different cases sprinkled within this page.
    -->
</div>

<app-page-content  [showWebFooter]="true" [usePagePadding]="true">
    <app-cobrand-header
            [property]="paymentSuccessInfo?.property.nickname"
            [manager]="paymentSuccessInfo?.property.hoa.pmc.name"
            [association]="paymentSuccessInfo?.property.hoa.name"
            [makePayment]="true"
    >
    </app-cobrand-header>

    <!-- One-time Payment -->
    <div *ngIf="successDisplay === 'payment'" class="HOA-misc-guidedSteps__container" >
        <div class="HOA-container__header">
            <!-- Conditional header based on feature flag -->
            <div *ngIf="!isAsyncFeatureEnabled" tid="paymentConfirmationTitle" class="HOA-container__header-text">
                Payment Confirmation
            </div>
            <div *ngIf="isAsyncFeatureEnabled" tid="paymentConfirmationTitle" class="HOA-container__header-text">
                Payment Pending
            </div>
        </div>
        <div class="HOA-container__content HOA-misc-guidedSteps__flex-extra-padded u-textCenter">
            <div class="HOA-splash__title--sm-bold u-pB5">
                <span tid="thankYou"> Thank you </span>
            </div>
            <!-- Conditional payment status message -->
            <div *ngIf="!isAsyncFeatureEnabled && isPaymentDateToday()" tid="paymentProcessed" class="u-pB4">
                Your payment for {{paymentSuccessInfo?.totalPaymentAmount | currency}} was processed.
            </div>
            <div *ngIf="!isAsyncFeatureEnabled && !isPaymentDateToday()" tid="paymentScheduledToBeProcessed" class="u-pB4">
                Your payment for {{paymentSuccessInfo?.totalPaymentAmount | currency}} is scheduled to be processed on {{paymentSuccessInfo?.paymentDate}}.
                <br>
                You may print this confirmation for your records.
            </div>
            <div *ngIf="isAsyncFeatureEnabled && !isPaymentDateToday()" tid="paymentScheduledToBeProcessed" class="u-pB4">
                Your payment for {{paymentSuccessInfo?.totalPaymentAmount | currency}} is scheduled to be processed on {{paymentSuccessInfo?.paymentDate}}.
                An email will be sent shortly when your payment has processed.
                <br>
                You may also print this page for your records.
            </div>
            <span tid="checkmarkIcon" class="Icon Icon--72 u-strokeGreenDarker u-mB8">
                        <svg xmlns="http://www.w3.org/2000/svg" width="72" height="72" viewBox="0 0 72 72">
                        <title *ngIf="!isAsyncFeatureEnabled">Payment Success</title>
                        <title *ngIf="isAsyncFeatureEnabled">Payment Pending</title>
                        <path d="M63.3 36a27 27 0 1 1-27-27 27 27 0 0 1 27 27z" fill="none" stroke="#838383" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"></path>
                        <path d="M23.9 39l9.1 9.3 15.6-24.6" fill="none" stroke="#838383" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"></path>
                        </svg>
                    </span>
            <!-- Confirmation number only shown for sync flow -->
            <div tid="confirmationNumber" class="u-pB4" *ngIf="paymentSuccessInfo?.confirmationNumber && !isAsyncFeatureEnabled">
                Confirmation #{{paymentSuccessInfo?.confirmationNumber}}
            </div>
            <div class="HOA-flex-component HOA-flex-component__column-center">
                <div class="u-pB4">
                    <button type="button" tid="printSuccessButton" id="printSuccessButton" class="Button Button--link" (click)="clickPrint()">Print</button>
                    <button type="button" tid="continueButton" id="okButton" class="Button Button--blue" (click)="goToHOAPay()">OK</button>
                </div>
            </div>
            <div class="u-mBS8" *ngIf="userStore.getSsoOrigin()" >
                Please close your browser tab to return to your homeowner portal or click
                <br>
                OK if you would like to make an additional payment
            </div>
            <div class="HOA-font-fine-print HOA-make-payment-disclaimer">
                <div>
                    Payments are processed Monday through Friday, excluding holidays.  Payments submitted on weekends or holidays may be delayed.
                </div>
                <!-- Cancel button only shown for sync flow -->
                <button tid="cancelButton" type="button" *ngIf="successDisplay === 'payment' && !isAsyncFeatureEnabled" (click)="cancelPreCancel()" class="Button--link u-pV2">
                    Cancel Payment
                </button>
            </div>
            <div id="thank-you-msg" class="HOA-splash-copy--light" [innerHTML]="thankYouMsg | inAppBrowserLink">
            </div>
        </div>
    </div>

    <!-- Schedule Payments - Designs: ISBMDPDPP-6340 "Registered User - Payment Schedule Confirmation Page is Incorrect" -->
    <div *ngIf="successDisplay === 'schedule'" class="HOA-misc-guidedSteps__container">
        <div class="HOA-container__header">
            <div tid="paymentScheduleConfirmationTitle" class="HOA-container__header-text">
                Payment Schedule Confirmation
            </div>
        </div>
        <div class="HOA-container__content u-textCenter">
            <div class="u-pB5">
                        <span tid="scheduleCreated" *ngIf="successDisplay === 'schedule'">
                            Your schedule for the property at
                            <span tid="addressLine1">{{paymentSuccessInfo?.property?.address?.line1}}</span>
                            was created.
                            <br>
                            You may print this confirmation for your records.
                        </span>
            </div>
            <div class="u-mB8">
                        <span tid="checkmarkIcon" class="Icon Icon--72 u-strokeGreenDarker">
                            <svg xmlns="http://www.w3.org/2000/svg" width="72" height="72" viewBox="0 0 72 72">
                                <title>Payment Success</title>
                                <path d="M63.3 36a27 27 0 1 1-27-27 27 27 0 0 1 27 27z" fill="none" stroke="#838383" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"></path>
                                <path d="M23.9 39l9.1 9.3 15.6-24.6" fill="none" stroke="#838383" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" ></path>
                            </svg>
                        </span>
            </div>
            <div class="u-mB2" *ngIf="paymentSuccessInfo?.paymentScheduleRequest?.frequency?.toLowerCase() != 'one-time' && paymentSuccessInfo?.paymentScheduleRequest?.endDate">
                Your {{(paymentSuccessInfo.paymentScheduleRequest.frequency || 'recurring').toLowerCase()}} payments are scheduled to end on {{getEndDateF("MMMM d, yyyy")}}.
            </div>
            <div class="u-mB8">
                To edit your schedule click
                <a tid="paymentScheduleLink" (click)="gotoSchedEdit()">here.</a>
            </div>
            <div class="HOA-flex-component HOA-flex-component__column-center">
                <div class="u-pB4">
                    <button type="button" tid="printSuccessButton" id="printSuccessButton" class="Button Button--link" (click)="clickPrint()">Print</button>
                    <button type="button" tid="okButton" id="continueButton" class="Button Button--blue" (click)="goToHOAPay()">OK</button>
                </div>
            </div>
            <div class="u-mBS8" *ngIf="userStore.getSsoOrigin()">
                Please close your browser tab to return to your homeowner portal or click
                <br>
                OK if you would like to make an additional payment
            </div>
            <div class="u-mB16"></div>
        </div>
    </div>
</app-page-content>`;
// Exports
module.exports = code;